import GET from "./get";

export {
    GET,
};



// WEBPACK FOOTER //
// src/client/actions/requests/index.js